(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6890],{

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SCREEN = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE"
};

var useResizeScreenModified = function useResizeScreenModified(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var _window3;

      var handleScreen = function handleScreen() {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.innerWidth) {
          var _window2;

          if (((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) <= 1023) {
            try {
              handler(SCREEN.TABLET);
            } catch (error) {
              console.error();
            }
          } else {
            try {
              handler(SCREEN.DESKTOP);
            } catch (error) {
              console.error();
            }
          }
        }
      };

      handleScreen();
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener("resize", handleScreen);
      return function () {
        var _window4;

        /* Clean up function. Remove event before component unmount. */
        (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.removeEventListener("resize", handleScreen);
      };
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResizeScreenModified);

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 91630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustpilotFeedBack; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/gr/GrFormNext.js

function GrFormNext(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "9 6 15 12 9 18"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/si/SiTrustpilot.js
var SiTrustpilot = __webpack_require__(9633);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/Index.module.scss
var Index_module = __webpack_require__(29850);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/TrustpilotFeedBack/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var dataStar = new Array(5).fill(1);
var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".swiper-trustpilot-dots",
    clickable: true,
    bulletClass: "bbc-pagination-bullet",
    bulletActiveClass: "bbc-pagination-bullet-active"
  },
  navigation: {
    nextEl: ".swiper-trustpilot-next",
    prevEl: ".swiper-trustpilot-prev"
  },
  slidesPerView: 1,
  spaceBetween: 40
};

var Component = function Component(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(null),
      thumbsSwiper = _useState[0],
      setThumbsSwiper = _useState[1];

  function isImage(url) {
    // eslint-disable-next-line prefer-named-capture-group
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-6 justify-between lg:mt-10 lg:flex",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper
        },
        modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl]
      }, swiper), {}, {
        className: "swiperFeelback bg-bbc-main ",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: "p-3 lg:p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: " w-full rounded-3xl bg-white py-6 px-8 shadow-[0px_0px_12px_rgba(119,119,119,0.25)] lg:rounded-none  lg:bg-transparent lg:p-0 lg:shadow-none",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center lg:justify-start",
                children: [isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: item.avatar,
                  className: "mr-6 rounded-full",
                  alt: item.name,
                  width: 80,
                  height: 80
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((Index_module_default()).avatar, " mr-6 flex items-center justify-center rounded-full font-bold"),
                  style: {
                    backgroundColor: item.bgAvatar
                  },
                  children: item.avatar
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mb-2  text-bbc-neutral-700",
                    children: item.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: dataStar.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "mr-1 flex h-6 w-6 items-center justify-center bg-[#00b67a] shadow-md",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                          className: "text-xl text-bbc-white"
                        })
                      }, index);
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "align-items-end mt-3  flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mr-0.5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                        className: "text-2xl text-[#00b67a]"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-xl font-medium text-bbc-black",
                      children: "Trustpilot"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "my-4 text-center font-semibold text-[#0042A3] opacity-[0.8] lg:text-left",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " text-center text-bbc-gray lg:text-left",
                children: item.content
              })]
            })
          }, index);
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative  text-center lg:col-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " hidden lg:flex lg:justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          onSwiper: setThumbsSwiper,
          spaceBetween: 5,
          slidesPerView: 3,
          freeMode: true,
          allowTouchMove: false,
          modules: [swiper_esm/* FreeMode */.Rv, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl],
          className: "swiperAvatar col-5 mr-2.5 ml-0",
          children: data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              className: "text-center",
              children: isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: item.avatar,
                className: "cursor-pointer rounded-full",
                alt: "avatar",
                width: 60,
                height: 60
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mx-auto flex  items-center justify-center rounded-full text-2xl font-bold",
                style: {
                  width: "60px",
                  height: "60px",
                  backgroundColor: item.bgAvatar
                },
                children: item.avatar
              })
            }, index);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " mt-6 hidden h-16 lg:block",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-next absolute flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnNext, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: " text-3xl"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-prev absolute  flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnPrev, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: "rotate-180 text-3xl"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper-trustpilot-dots  pt-6 "
      })]
    })]
  });
};

/* harmony default export */ var TrustpilotFeedBack = (Component);

/***/ }),

/***/ 73579:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = noSSR;
exports["default"] = dynamic;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _loadable = _interopRequireDefault(__webpack_require__(23668));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var isServerSide = false;

function noSSR(LoadableInitializer, loadableOptions) {
  // Removing webpack and modules means react-loadable won't try preloading
  delete loadableOptions.webpack;
  delete loadableOptions.modules; // This check is necessary to prevent react-loadable from initializing on the server

  if (!isServerSide) {
    return LoadableInitializer(loadableOptions);
  }

  var Loading = loadableOptions.loading; // This will only be rendered on the server side

  return function () {
    return /*#__PURE__*/_react["default"].createElement(Loading, {
      error: null,
      isLoading: true,
      pastDelay: false,
      timedOut: false
    });
  };
}

function dynamic(dynamicOptions, options) {
  var loadableFn = _loadable["default"];
  var loadableOptions = {
    // A loading component is not required, so we default it
    loading: function loading(_ref) {
      var error = _ref.error,
          isLoading = _ref.isLoading,
          pastDelay = _ref.pastDelay;
      if (!pastDelay) return null;

      if (false) {}

      return null;
    }
  }; // Support for direct import(), eg: dynamic(import('../hello-world'))
  // Note that this is only kept for the edge case where someone is passing in a promise as first argument
  // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
  // To make sure we don't execute the import without rendering first

  if (dynamicOptions instanceof Promise) {
    loadableOptions.loader = function () {
      return dynamicOptions;
    }; // Support for having import as a function, eg: dynamic(() => import('../hello-world'))

  } else if (typeof dynamicOptions === 'function') {
    loadableOptions.loader = dynamicOptions; // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
  } else if (typeof dynamicOptions === 'object') {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), dynamicOptions);
  } // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})


  loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), options);
  var suspenseOptions = loadableOptions;

  if (true) {
    // Error if react root is not enabled and `suspense` option is set to true
    if ( true && suspenseOptions.suspense) {
      // TODO: add error doc when this feature is stable
      throw new Error("Invalid suspense option usage in next/dynamic. Read more: https://nextjs.org/docs/messages/invalid-dynamic-suspense");
    }
  }

  if (suspenseOptions.suspense) {
    return loadableFn(suspenseOptions);
  } // coming from build/babel/plugins/react-loadable-plugin.js


  if (loadableOptions.loadableGenerated) {
    loadableOptions = _objectSpread(_objectSpread({}, loadableOptions), loadableOptions.loadableGenerated);
    delete loadableOptions.loadableGenerated;
  } // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})


  if (typeof loadableOptions.ssr === 'boolean') {
    if (!loadableOptions.ssr) {
      delete loadableOptions.ssr;
      return noSSR(loadableFn, loadableOptions);
    }

    delete loadableOptions.ssr;
  }

  return loadableFn(loadableOptions);
}

/***/ }),

/***/ 3982:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.LoadableContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var LoadableContext = _react["default"].createContext(null);

exports.LoadableContext = LoadableContext;

if (false) {}

/***/ }),

/***/ 23668:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _classCallCheck = __webpack_require__(2553);

var _createClass = __webpack_require__(62012);

var _defineProperty = __webpack_require__(61682);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _useSubscription = __webpack_require__(67161);

var _loadableContext = __webpack_require__(3982);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;

function load(loader) {
  var promise = loader();
  var state = {
    loading: true,
    loaded: null,
    error: null
  };
  state.promise = promise.then(function (loaded) {
    state.loading = false;
    state.loaded = loaded;
    return loaded;
  })["catch"](function (err) {
    state.loading = false;
    state.error = err;
    throw err;
  });
  return state;
}

function resolve(obj) {
  return obj && obj.__esModule ? obj["default"] : obj;
}

function createLoadableComponent(loadFn, options) {
  var opts = Object.assign({
    loader: null,
    loading: null,
    delay: 200,
    timeout: null,
    webpack: null,
    modules: null,
    suspense: false
  }, options);

  if (opts.suspense) {
    opts.lazy = _react["default"].lazy(opts.loader);
  }

  var subscription = null;

  function init() {
    if (!subscription) {
      var sub = new LoadableSubscription(loadFn, opts);
      subscription = {
        getCurrentValue: sub.getCurrentValue.bind(sub),
        subscribe: sub.subscribe.bind(sub),
        retry: sub.retry.bind(sub),
        promise: sub.promise.bind(sub)
      };
    }

    return subscription.promise();
  } // Server only


  if (false) {} // Client only


  if (!initialized && true && typeof opts.webpack === 'function' && "function" === 'function' && !opts.suspense) {
    var moduleIds = opts.webpack();
    READY_INITIALIZERS.push(function (ids) {
      var _iterator = _createForOfIteratorHelper(moduleIds),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var moduleId = _step.value;

          if (ids.indexOf(moduleId) !== -1) {
            return init();
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  function LoadableImpl(props, ref) {
    init();

    var context = _react["default"].useContext(_loadableContext.LoadableContext);

    var state = (0, _useSubscription).useSubscription(subscription);

    _react["default"].useImperativeHandle(ref, function () {
      return {
        retry: subscription.retry
      };
    }, []);

    if (context && Array.isArray(opts.modules)) {
      opts.modules.forEach(function (moduleName) {
        context(moduleName);
      });
    }

    return _react["default"].useMemo(function () {
      if (state.loading || state.error) {
        return _react["default"].createElement(opts.loading, {
          isLoading: state.loading,
          pastDelay: state.pastDelay,
          timedOut: state.timedOut,
          error: state.error,
          retry: subscription.retry
        });
      } else if (state.loaded) {
        return _react["default"].createElement(resolve(state.loaded), props);
      } else {
        return null;
      }
    }, [props, state]);
  }

  function LazyImpl(props, ref) {
    return _react["default"].createElement(opts.lazy, _objectSpread(_objectSpread({}, props), {}, {
      ref: ref
    }));
  }

  var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;

  LoadableComponent.preload = function () {
    return !opts.suspense && init();
  };

  LoadableComponent.displayName = 'LoadableComponent';
  return _react["default"].forwardRef(LoadableComponent);
}

var LoadableSubscription = /*#__PURE__*/function () {
  function LoadableSubscription(loadFn, opts) {
    _classCallCheck(this, LoadableSubscription);

    this._loadFn = loadFn;
    this._opts = opts;
    this._callbacks = new Set();
    this._delay = null;
    this._timeout = null;
    this.retry();
  }

  _createClass(LoadableSubscription, [{
    key: "promise",
    value: function promise() {
      return this._res.promise;
    }
  }, {
    key: "retry",
    value: function retry() {
      var _this = this;

      this._clearTimeouts();

      this._res = this._loadFn(this._opts.loader);
      this._state = {
        pastDelay: false,
        timedOut: false
      };
      var res = this._res,
          opts = this._opts;

      if (res.loading) {
        if (typeof opts.delay === 'number') {
          if (opts.delay === 0) {
            this._state.pastDelay = true;
          } else {
            this._delay = setTimeout(function () {
              _this._update({
                pastDelay: true
              });
            }, opts.delay);
          }
        }

        if (typeof opts.timeout === 'number') {
          this._timeout = setTimeout(function () {
            _this._update({
              timedOut: true
            });
          }, opts.timeout);
        }
      }

      this._res.promise.then(function () {
        _this._update({});

        _this._clearTimeouts();
      })["catch"](function (_err) {
        _this._update({});

        _this._clearTimeouts();
      });

      this._update({});
    }
  }, {
    key: "_update",
    value: function _update(partial) {
      this._state = _objectSpread(_objectSpread({}, this._state), {}, {
        error: this._res.error,
        loaded: this._res.loaded,
        loading: this._res.loading
      }, partial);

      this._callbacks.forEach(function (callback) {
        return callback();
      });
    }
  }, {
    key: "_clearTimeouts",
    value: function _clearTimeouts() {
      clearTimeout(this._delay);
      clearTimeout(this._timeout);
    }
  }, {
    key: "getCurrentValue",
    value: function getCurrentValue() {
      return this._state;
    }
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this2 = this;

      this._callbacks.add(callback);

      return function () {
        _this2._callbacks["delete"](callback);
      };
    }
  }]);

  return LoadableSubscription;
}();

function Loadable(opts) {
  return createLoadableComponent(load, opts);
}

function flushInitializers(initializers, ids) {
  var promises = [];

  while (initializers.length) {
    var init = initializers.pop();
    promises.push(init(ids));
  }

  return Promise.all(promises).then(function () {
    if (initializers.length) {
      return flushInitializers(initializers, ids);
    }
  });
}

Loadable.preloadAll = function () {
  return new Promise(function (resolveInitializers, reject) {
    flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
  });
};

Loadable.preloadReady = function () {
  var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return new Promise(function (resolvePreload) {
    var res = function res() {
      initialized = true;
      return resolvePreload();
    }; // We always will resolve, errors should be handled within loading UIs.


    flushInitializers(READY_INITIALIZERS, ids).then(res, res);
  });
};

if (true) {
  window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}

var _default = Loadable;
exports["default"] = _default;

/***/ }),

/***/ 91513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/data/trustpilot/data.json
var trustpilot_data = __webpack_require__(54356);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./common/priceConvert.js
var priceConvert = __webpack_require__(46518);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FaqsGroup/index.js + 1 modules
var FaqsGroup = __webpack_require__(69156);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/PackagesNews/index.js + 1 modules
var PackagesNews = __webpack_require__(30913);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/index.js + 1 modules
var TrustpilotFeedBack = __webpack_require__(91630);
// EXTERNAL MODULE: ./components/molecules/CardPackage/Index.module.scss
var Index_module = __webpack_require__(67148);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/sg/corporate-secretary/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/* Data */




/* Components
 */















var CorporateSecretary = function CorporateSecretary(_ref) {
  var dataJson = _ref.dataJson,
      data = _ref.data;

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: " min-h-[503px]",
      wave: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 absolute bottom-0 hidden lg:block ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/wave/curve_top-wave.svg",
          className: "h-full w-full",
          width: 516,
          wrapper: {
            className: "w-full h-full"
          },
          height: 420,
          alt: "banner-img"
        })
      }),
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: "Intensive Paperwork Holding You Down? Our Corporate Secretarial Service Can Help With That",
      leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "mb-0 text-center lg:col-11 lg:mb-14 lg:text-left ",
        children: "We make sure the only work you\u2018re swimming in is growing your business, not in a sea of documents. Keep up with all your filing obligations and never miss a deadline again."
      }),
      titleProps: {
        className: " xl:text-4xl mb-6   text-bbc-30px font-semibold  xl:leading-[50px] text-center lg:text-left",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-6",
      rightClassName: "lg:col-6",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/sg/corporate-secretary/banner-sg-secretary.png",
        wrapper: {
          className: "bbc-banner-image-bottom-0 lg:max-w-[530px]"
        },
        className: "",
        width: 657,
        height: 524,
        alt: "Singapore company secretarial service"
      }),
      bgColor: "bg-bbc-country"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-bbc-brand-100 pt-10 lg:pt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "mb-10 pb-10 lg:mb-0",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6",
            children: "Singapore Secretarial Service"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-6",
            children: "By law, every company in Singapore must have at least one corporate secretary under the Companies Act 1967 who will take on admistrative duties."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: "Our corporate secretaries will take care of neccessary filing obligations and act as a main point of contact for any future interactions your company may have with legislators."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row items-center justify-between",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "lg:col-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "bbc-title-30 text-2xl leading-9",
                  children: "Faciliating meetings"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  children: "From AGM to board meetings, they make sure you\u2018re at the right place and time."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "text-center lg:col-6 lg:text-right",
                children: [" ", /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/sg/corporate-secretary/service1-sg-secretary.png",
                  width: 496,
                  height: 406,
                  alt: "facilitate company meeting"
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row flex-col-reverse items-center justify-start lg:flex-row",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:col-6 lg:text-left",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/sg/corporate-secretary/service2-sg-secretary.png",
                  width: 452,
                  height: 417,
                  alt: "update company information"
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "lg:col-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "bbc-title-30 text-2xl leading-9",
                  children: "Updating your information in the registers"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-6",
                  children: "Whether it\u2018s a change in key personnel or simply a letter in your company name, nothing goes unnoticed and gets updated to the Register almost as they happen."
                })]
              })]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-0 lg:mt-10",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "row items-center justify-between ",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "lg:col-6",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                  as: "h3",
                  className: "bbc-title-30 text-2xl leading-9",
                  children: "Ensuring that your company stay compliant"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mb-6 lg:mb-0",
                  children: "You\u2018ll always be confident to know that there\u2018s always someone behind the scenes in charge of safeguarding your company from legal troubles."
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "text-center lg:col-6 lg:text-right",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: "/assets/images/sg/corporate-secretary/service3-sg-secretary.png",
                  width: 504,
                  height: 367,
                  alt: "ensure compliance"
                })
              })]
            })
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 mb-10 hidden lg:mb-20 lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/curve_bot-wave.svg",
        className: "h-full w-full",
        width: 516,
        wrapper: {
          className: "w-full h-full"
        },
        height: 420,
        alt: "banner-img"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "pb-10 lg:pb-20",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PackagesNews/* default */.Z, _objectSpread(_objectSpread({}, dataJson.dataPackage), {}, {
            data: (data === null || data === void 0 ? void 0 : data.packages.dataPackage) || [],
            dataStatic: dataJson.dataPackage,
            title: "Pricing",
            changePrice: true,
            tabBarClass: "hidden",
            customCardColor: {
              text: ["text-bbc-brand-500", "text-bbc-brand-700", "text-bbc-yellow-500"],
              border: ["lg:hover:border-bbc-brand-500", "lg:hover:border-bbc-brand-700", "lg:hover:border-bbc-yellow-500"],
              button: ["bg-bbc-brand-500 ".concat((Index_module_default()).btnBlue), "bg-bbc-brand-700 ".concat((Index_module_default()).btnDarkBlue), "bg-bbc-yellow-500 ".concat((Index_module_default()).btnYellow)]
            }
          }))
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
          children: "Non-routine Corporate Secretary Services"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
          data: dataJson.dataPricing.data.map(function (item) {
            return item.tab;
          }),
          activeTab: dataJson.dataPricing.activeTab,
          tabListClass: {
            display: "flex lg:justify-center",
            length: "w-full",
            padding: "px-1 py-3",
            border: "border-0",
            othersClass: "whitespace-nowrap overflow-x-auto mb-20 lg:mb-6"
          },
          tabClass: {
            padding: "py-2 px-4 ",
            tabColor: "text-bbc-neutral-600 border-bbc-neutral-600 hover:text-bbc-brand-500 hover:border-bbc-brand-500",
            othersClass: "mr-2 last:mr-0 font-medium"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
            children: dataJson.dataPricing.data.map(function (item, index) {
              var _item$table, _item$table$thead, _item$table2, _item$table2$tbody, _item$table3, _item$table3$tbody;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                className: "focus:outline-none focus:outline-0 focus:ring-0",
                as: "div",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "shadow-bbc-table mt-10 hidden overflow-x-auto rounded-3xl lg:block",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
                    className: " text-left text-sm text-bbc-gray ",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
                      className: "col-12 bg-bbc-brand-700  text-2xl  text-bbc-white ",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
                        children: (_item$table = item.table) === null || _item$table === void 0 ? void 0 : (_item$table$thead = _item$table.thead) === null || _item$table$thead === void 0 ? void 0 : _item$table$thead.map(function (thead, index) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                            className: "".concat(thead.width, " py-8 text-center font-semibold"),
                            children: thead.name
                          }, index);
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
                      children: (_item$table2 = item.table) === null || _item$table2 === void 0 ? void 0 : (_item$table2$tbody = _item$table2.tbody) === null || _item$table2$tbody === void 0 ? void 0 : _item$table2$tbody.map(function (thead, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                          className: " bg-bbc-white even:bg-bbc-brand-100",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                            className: "w-1/6 px-4 py-6 align-top font-medium text-bbc-brand-700",
                            children: thead.title
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                            className: "relative w-4/6 py-6  before:absolute before:left-0 before:top-6 before:h-[calc(100%_-_48px)] before:w-[1px] before:bg-bbc-neutral-700 before:content-[''] after:absolute after:right-0 after:top-6 after:h-[calc(100%_-_48px)] after:w-[1px] after:bg-bbc-neutral-700 after:content-['']",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                              className: "px-6",
                              dangerouslySetInnerHTML: {
                                __html: (0,priceConvert/* convertPriceOnString */.eY)(thead.description)
                              }
                            })
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                            className: "w-1/6 px-4 py-6 text-center align-top ",
                            children: thead.pricing ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                              className: "list-disc font-semibold text-bbc-brand-700",
                              dangerouslySetInnerHTML: {
                                __html: (0,priceConvert/* convertPriceOnString */.eY)(thead.pricing)
                              }
                            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                              href: "/contact-us",
                              className: "pl-4 font-semibold text-bbc-brand-700",
                              children: "Contact us"
                            })
                          })]
                        }, index);
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mt-6 block lg:hidden",
                  children: (_item$table3 = item.table) === null || _item$table3 === void 0 ? void 0 : (_item$table3$tbody = _item$table3.tbody) === null || _item$table3$tbody === void 0 ? void 0 : _item$table3$tbody.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mb-4  rounded-2xl bg-bbc-white shadow-[0_16px_40px_0_rgba(181,181,181,0.25)]",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                        className: "border-b border-bbc-neutral-500 py-4 text-center font-medium text-bbc-brand-600",
                        children: item.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "border-b border-bbc-neutral-500 py-6 px-7 text-center",
                        dangerouslySetInnerHTML: {
                          __html: (0,priceConvert/* convertPriceOnString */.eY)(item.description)
                        }
                      }), item.pricing ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "list-inside list-disc py-4 pl-4 text-center font-semibold text-bbc-brand-700",
                        dangerouslySetInnerHTML: {
                          __html: (0,priceConvert/* convertPriceOnString */.eY)(item.pricing)
                        }
                      }) : /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "py-4 pl-4 text-center",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                          href: "/contact-us",
                          className: "font-semibold text-bbc-brand-700 ",
                          children: "Contact us"
                        })
                      })]
                    }, index);
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                  className: "mt-4 text-sm italic",
                  children: item.note
                })]
              }, index);
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
          children: "Tired of red tapes? Go blue today"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: " m-auto text-center lg:col-8 ",
          children: "We stay grounded with compliance matters so you can be free to live that entrepreneur life. Sit back and let everything get taken care of in the background."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-10 justify-between",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 flex items-center lg:col-5",
            children: screen === "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaqsGroup/* default */.Z, {
              data: dataJson.dataProactive,
              buttonClass: "!pl-0"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: dataJson.dataProactive.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "mx-4 mb-10 text-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    dangerouslySetInnerHTML: {
                      __html: item.name
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                      __html: item.content
                    }
                  })]
                }, index);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "order-first lg:col-6 lg:order-last ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/sg/corporate-secretary/service4-sg-secretary.png",
              width: 539,
              height: 422,
              alt: "why choose our Singapore company secretary service"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "m-auto lg:col-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
            children: "What customers say about BBCIncorp"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-center",
            children: "Our skillful secretary have helped thousands of businesses like yours with their corporate governance."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotFeedBack/* default */.Z, {
            data: trustpilot_data/* feedback */.I
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "mb-10 lg:mb-0",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mx-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z, {
            data: dataJson.dataFaqs,
            description: " "
          })
        })
      })
    })]
  });
};

/* harmony default export */ var corporate_secretary = (CorporateSecretary);
;// CONCATENATED MODULE: ./pages/sg/company-secretary/data.json
var company_secretary_data_namespaceObject = JSON.parse('{"breadcrumbs":[{"uri":"/","title":"Home"},{"uri":"/corporate-secretary","title":"Company Secretary"}],"dataPackage":{"title":"Singapore Company Incorporation Packages","listPackage":[{"id":90,"country_id":191,"kind":"Startup for locals","kind_mobile":"Basic","price":210,"subPrice":"/year","sale_off":10,"className":"","pauseRegister":true,"banner":"","checkName":true,"suffix_name":"Private Limited","content":[{"listContent":[{"text":"Preparation of AGM"},{"text":"Preparation and submission of Annual Returns (SG$60 ACRA filing fee included)"},{"text":"Managing Register and Minutes books"},{"text":"Limited number of changes*"}]}]},{"id":91,"kind":"standard","kind_mobile":"Standard","price":559,"subPrice":"/year","sale_off":33,"className":"","pauseRegister":true,"banner":"","content":[{"listContent":[{"text":"<span class=\'text-bbc-brand-700 font-semibold\'>12-month prestige registered address<span>"},{"text":"Mail handling (and scanning when requested)"},{"text":"Preparation of AGM and EGM"},{"text":"Filing and submission of Annual Returns (SG$60 ACRA filing fee included)"},{"text":"Managing Register and Minutes books"},{"text":"Unlimited number of changes**"}]}]},{"id":92,"kind":"Standard with Employment Pass","kind_mobile":"Premium","price":992,"subPrice":"/year","sale_off":68,"best_seller":true,"seller_content":"Most Popular","className":"","pauseRegister":true,"content":[{"preTitle":"CORPSEC UNLIMITED, including:","subTitle":"<span>Accounting & Tax filings: <span class=\'font-normal\'>For yearly revenue of SG$70,000 <i>(plan upgradable)</i></span></span>","listContent":[{"text":"Corppass registration"},{"text":"Unaudited financial statements"},{"text":"Annual tax filings"}]}]}],"note":"<p>* Up to 3 changes, exclude stamp duties</p><p>** Exclude stamp duties</p><p>- Additional KYC fees are applicable for companies with more than 5 members</p>"},"dataPricing":{"activeTab":0,"data":[{"tab":"Change Company Particulars","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Company name","description":{"content":"Update changes in your company name"},"pricing":{"content":"${price}","paramsContent":{"price":"45"},"unit":1}},{"title":"Registered address","description":{"content":"Update changes in your company\'s registered address"},"pricing":{"content":"${price}","paramsContent":{"price":"38"},"unit":1}},{"title":"Articles of Associations","description":{"content":"Update changes in company constitution, i.e, hold a general meeting or issue new classes of shares"},"pricing":{"content":"${price}","paramsContent":{"price":"38"},"unit":1}},{"title":"Business activities","description":{"content":"Update changes in the company\'s business activity"},"pricing":{"content":"${price}","paramsContent":{"price":"38"},"unit":1}}]}},{"tab":"Change company\'s officers","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Change officer\'s particulars ","description":{"content":"Update changes in officer\'s particulars like name, identification number, residential address, etc.<br />+${price} for each additional officer.","paramsContent":{"price":"38"},"unit":1},"pricing":{"content":"${price}","paramsContent":{"price":"75"},"unit":1}},{"title":"Appoint new officers","description":{"content":"Update appointment resolution of 1 officer.<br />+${price} for each additional appointment","paramsContent":{"price":"38"},"unit":1},"pricing":{"content":"${price}","paramsContent":{"price":"75"},"unit":1}},{"title":"Remove/Resign officers","description":{"content":"Update removal resolution of 1 personnel<br />+${price} for each additional change","paramsContent":{"price":"38"},"unit":1},"pricing":{"content":"${price}","paramsContent":{"price":"75"},"unit":1}}]}},{"tab":"Share related changes","note":"*prices exclude stamp duties","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Increase/Decrease of capital","description":{"content":"To raise fund, you must issue more share certificates to shareholders that is specified in the constitutional documents."},"pricing":{"content":"${price}","paramsContent":{"price":"150"},"unit":1}},{"title":"Issue and allot shares","description":{"content":"Notify the Registrar about the allotment of new shares"},"pricing":{"content":"${price}","paramsContent":{"price":"150"},"unit":1}},{"title":"Transfer shares","description":{"content":"Support in preparing and filing share transfer documents when you want to change the share structure between company members."},"pricing":{"content":"${price}","paramsContent":{"price":"150"},"unit":1}}]}}]},"dataProactive":[{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>One-to-one consulting</span>","content":"We have our dedicated team of consultants that attends to the specific needs of your business."},{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Time efficiency</span>","content":"Less paperwork, more time on growing. We\'ll care for all your ongoing compliance and daunting paperwork. So you have more time focusing on what really matters!"},{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>No hidden fee</span>","content":"We prioritize truth and honest in our working manner and in dealing with our customers. No hidden charges guaranteed."}],"dataFaqs":[{"name":"What are Singapore corprorate secretary duties and functions?","content":"<p>The duties and functions of a Singapore corporate secretary are wide in scope. Mostly ranging from administrative to managerial function.</p><p>Below are some main duties you should know about:</p><ul ><li>Filing and updating with ACRA annual accounts and any particulars and status change of the company/directors</li><li>Maintaining and updating documents such as statutory registers of the company, minutes books of meetings</li><li>Arranging the company meetings</li><li>Handling other administrative matters</li></ul>"},{"name":"When to appoint a corporate secretary?","content":"<p>According to ACRA, every local company must appoint at least one secretary. Section 171 (4) of the Companies Act also prescribed that the office of secretary shall not be left vacant for more than 6 months at any time.</p>"},{"name":"Why outsourcing corporate secretarial services is more efficient?","content":"<p>The shift from hiring a corporate secretary to outsourcing one from corporate secretarial services has gained significant attention over the years.</p><p>This is due to the following reasons:</p><ul><li class=\'font-semibold\'>Costs effective</li></ul><p>The corporate secretarial services would charge much lower for the same role.</p><p>By outsourcing, you can also cut training and recruitment costs associated with the secretary.</p><ul><li  class=\'font-semibold\'>Expertise</li></ul><p>Corporate secretarial services develop a certain level of expertise. This enables them to get things done accurately and quickly</p><p>For your company, this means achieving goals faster and avoiding mistakes that could hurt business bottom line.</p><ul><li  class=\'font-semibold\'>No more regulatory burden</li></ul><p>Outsourcing corporate secretarial role relief you from the stress of registration and compliance matters.</p><p>This means you have more time, energy, and resources to focus on business growth and development.</p><p>BBCIncorp\'s services help you fulfill the mandatory laws while saving costs on headcount and training.</p><p><a class=\'text-bbc-primary\' target=\'_blank\' href=\'/sg/contact-us\'>Get in touch</a> with us if you&rsquo;re interested or need any help.</p>"}]}');
;// CONCATENATED MODULE: ./pages/sg/company-secretary/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "sg",
      page: data === null || data === void 0 ? void 0 : data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(corporate_secretary, {
        data: data,
        dataJson: company_secretary_data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 65155:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sg/company-secretary",
      function () {
        return __webpack_require__(91513);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 29850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Index_avatar__N4Fw5","btnNext":"Index_btnNext__swLTJ","btnPrev":"Index_btnPrev__KZ1Lh"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(73579)


/***/ }),

/***/ 27884:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = true;
exports["default"] = JSXStyle;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _stylesheetRegistry = __webpack_require__(28122);

var _hash = __webpack_require__(39035);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Opt-into the new `useInsertionEffect` API in React 18, fallback to `useLayoutEffect`.
// https://github.com/reactwg/react-18/discussions/110
var useInsertionEffect = _react["default"].useInsertionEffect || _react["default"].useLayoutEffect;

function JSXStyle(props) {
  var registry = (0, _stylesheetRegistry.useStyleRegistry)(); // If `registry` does not exist, we do nothing here.

  if (!registry) {
    return null;
  }

  if (typeof window === 'undefined') {
    registry.add(props);
    return null;
  }

  useInsertionEffect(function () {
    registry.add(props);
    return function () {
      registry.remove(props);
    }; // props.children can be string[], will be striped since id is identical
  }, [props.id, String(props.dynamic)]);
  return null;
}

JSXStyle.dynamic = function (info) {
  return info.map(function (tagInfo) {
    var baseId = tagInfo[0];
    var props = tagInfo[1];
    return (0, _hash.computeId)(baseId, props);
  }).join(' ');
};

/***/ }),

/***/ 65988:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(27884)


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 51423:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _construct; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(36129);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/construct.js


function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) (0,setPrototypeOf/* default */.Z)(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

/***/ }),

/***/ 49711:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(16988);
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 54356:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"I":[{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#e6f5ee","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight to the point response with so solid grasp on the needs of the client.","stars":5},{"name":"Siddhant Choyal","avatar":"SC","bgAvatar":"#9df5cc","title":"My #1 recommendation for company registrations","content":"Daisy will guide you through everything and reply almost instantly 100% of the times. If you\'re looking got a HK LTD company, BBCIncorp would be my #1 recommendation. They do above and beyond, it was an absolute breeze working with them.","stars":5},{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#dfeef5","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight-to-the-point response with so solid grasp on the needs of the client.","stars":5},{"name":"Suraj","avatar":"SU","bgAvatar":"#bfd7e3","title":"Best Service !","content":"I had the pleasure of dealing with Daisy to incorporate my company, the staff at BBCincorp are professional, knowledgable and cost-effective! best service, best price and extremely competent. Would recommend it again !","stars":5},{"name":"Hasitha Dissanayake","avatar":"HD","bgAvatar":"#cdcfc8","title":"Thanks to Laura and the team for their…","content":"Thanks to Laura and the team for their professionalism and responsiveness to assist us in our company formation and bank account opening, can recommend them to anyone.","stars":5},{"name":"Michael Stoeckle","avatar":"MS","bgAvatar":"#cccfc8","title":"Great job is done by BBCIncorp","content":"The team from BBCIncorp was very fast in responding; I had an active and fruitful dialogue while the company was set up: The new venture was fully operational in less than a week which is great.","stars":5},{"name":"Jeremy","avatar":"JE","bgAvatar":"#f4fcc5","title":"Very good company","content":"Very good company. You can trust them. Frankly, this is the first time I have had to deal with a competent accountant. It changes greatly from France ^^. I had lost hope that a competent accountant existed in this world. BBCincorp gave me hope","stars":5},{"name":"Frank Duffy","avatar":"FD","bgAvatar":"#cef4f5","title":"I found BBCIncorp very easy to deal with…","content":"I found BBCIncorp very easy to deal with, they explained everything in detail from the beginning and answered any queries I had very quickly. They were efficient, pleasant to work with & I would have no problem recommending them to anyone.","stars":5},{"name":"Andrii Ch","avatar":"AC","bgAvatar":"#cef6f4","title":"Highly professional and responsive experts","content":"BBC Incorp is one of a kind international legal consultant and advisor of the highest caliber. I especially recommend working with Mrs. Linda Chen, who is a first-class legal specialist.","stars":5}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3105,8352,4090,9738,7447,9156,913,2888,179], function() { return __webpack_exec__(65155); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);